import logger from "@utils/logger";
import {
  postSubscription,
  deleteSubscription,
  getProfile,
  putProfile,
  postUserPaymentMethod,
  postPauseSubscription,
  postRestartSubscription,
  postCancelSuspension,
  postChangeSubscriptionPlan,
  getUserProductsLiked,
  getUserProductsRented,
} from "@utils/call-api/users-call";
import { postRating } from "@utils/call-api/feedbacks-call";
import { like, dislike } from "@utils/call-api/products-call";
import {
  openAddedToWishlistToast,
  closeAddedToWishlistToast,
  reloadUserLists,
} from "@actions/userlists-actions";
import { animateWishlistIcon } from "@utils/animations";

export const TYPES = {
  UPDATE_SUBSCRIPTION: "UPDATE_SUBSCRIPTION",
  SUBSCRIPTION_SUCCESS: "SUBSCRIPTION_SUCCESS",
  UPDATE_PROFILE_INFOS: "UPDATE_PROFILE_INFOS",
  SET_DEFAULT_PAYMENT_METHOD: "SET_DEFAULT_PAYMENT_METHOD",
  DISABLE_FEEDBACK_AVAILABLE: "DISABLE_FEEDBACK_AVAILABLE",
  SET_PRODUCTS_LIKED: "SET_PRODUCTS_LIKED",
  SET_PRODUCTS_RENTED: "SET_PRODUCTS_RENTED",
};

function updateSubscription(subscription) {
  return {
    type: TYPES.UPDATE_SUBSCRIPTION,
    subscription,
  };
}

function subscriptionSuccess() {
  return {
    type: TYPES.SUBSCRIPTION_SUCCESS,
  };
}

function updateProfileInfos(profileInfos) {
  return {
    type: TYPES.UPDATE_PROFILE_INFOS,
    profileInfos,
  };
}

function setPaymentMethod(paymentMethod) {
  return {
    type: TYPES.SET_DEFAULT_PAYMENT_METHOD,
    default_payment_method: paymentMethod,
  };
}

function setProductsLiked(productsLiked) {
  return {
    type: TYPES.SET_PRODUCTS_LIKED,
    productsLiked,
  };
}

function setProductsRented(productsRented) {
  return {
    type: TYPES.SET_PRODUCTS_RENTED,
    productsRented,
  };
}

function disableFeedbackAvailable() {
  return (dispatch) => {
    dispatch({
      type: TYPES.DISABLE_FEEDBACK_AVAILABLE,
    });
  };
}

export function createSubscription(newSubscription) {
  return async (dispatch) => {
    try {
      const subscription = await postSubscription(newSubscription);

      logger.debug("DISPATCH updateSubscription");
      dispatch(updateSubscription(subscription));

      logger.debug("DISPATCH subscriptionSuccess");
      dispatch(subscriptionSuccess());
      return subscription;
    } catch (err) {
      throw err.response;
    }
  };
}

export function changeSubscriptionPlan() {
  return async (dispatch) => {
    try {
      const subscription = await postChangeSubscriptionPlan();

      dispatch(updateSubscription(subscription));
      return subscription.plan_price.plan;
    } catch (err) {
      throw err.response;
    }
  };
}

export function cancelSuspension() {
  return async (dispatch) => {
    try {
      const subscription = await postCancelSuspension();

      dispatch(updateSubscription(subscription));
    } catch (err) {
      dispatch(updateSubscription(err.response.data.data));
      throw err;
    }
  };
}

export function restartSubscription() {
  return async (dispatch) => {
    try {
      const subscription = await postRestartSubscription();

      dispatch(updateSubscription(subscription));
      return subscription;
    } catch (err) {
      dispatch(updateSubscription(err.response?.data?.data));
      throw err;
    }
  };
}

export function cancelSubscription(data) {
  return async (dispatch) => {
    const subscription = await deleteSubscription(data);
    dispatch(updateSubscription(subscription));
  };
}

export function pauseSubscription(data) {
  return async (dispatch) => {
    const subscription = await postPauseSubscription(data);

    dispatch(updateSubscription(subscription));
  };
}

export function reloadUser() {
  return async (dispatch) => {
    const user = await getProfile();
    dispatch(updateProfileInfos(user));
    return user;
  };
}

export function editProfile(data) {
  return async (dispatch) => {
    try {
      const profileInfos = await putProfile({ user: data });
      dispatch(updateProfileInfos(profileInfos));
    } catch (err) {
      throw err.response;
    }
  };
}

export function postPaymentMethod(setupIntentId) {
  return async (dispatch) => {
    const paymentMethod = await postUserPaymentMethod(setupIntentId);
    await dispatch(setPaymentMethod(paymentMethod));
  };
}

export function getProductsLiked() {
  return async (dispatch) => {
    const productsLiked = await getUserProductsLiked();
    dispatch(setProductsLiked(productsLiked));
  };
}

export function likeProduct(product) {
  return async (dispatch) => {
    dispatch(closeAddedToWishlistToast());

    const productsLiked = await like(product.id);

    animateWishlistIcon();

    dispatch(setProductsLiked(productsLiked));
    dispatch(openAddedToWishlistToast(product));
  };
}

export function dislikeProduct(productId) {
  return async (dispatch) => {
    const productsLiked = await dislike(productId);
    dispatch(setProductsLiked(productsLiked));
    dispatch(reloadUserLists());
  };
}

export function getProductsRented() {
  return async (dispatch) => {
    const productsRented = await getUserProductsRented();
    dispatch(setProductsRented(productsRented));
  };
}

export function postFeedbackRating(rating, closetId) {
  return async (dispatch) => {
    const res = await postRating(rating, closetId);
    dispatch(disableFeedbackAvailable());
    return res;
  };
}
